<template>
  <header class="dvs-header">
    <div class="dvs-header-brand">
      {{ brand }}
    </div>

    <div class="dvs-stepper" aria-label="Progreso del formulario">
      <span
        v-for="n in totalSteps"
        :key="n"
        class="dvs-stepper-dot"
        :class="{ 'is-active': n === step, 'is-done': n < step }"
      ></span>
    </div>
  </header>
</template>

<script setup>
defineProps({
  brand: {
    type: String,
    default: 'VENA Y SCRAP'
  },
  step: {
    type: Number,
    required: true
  },
  totalSteps: {
    type: Number,
    default: 5
  }
})
</script>
